const getters = {
    getAttributes(state){
        return state.attributes;
    },
    getAttribute(state){
        return state.attribute
    }
}

export default getters;